import { faker } from '@faker-js/faker/locale/af_ZA'
import { http, HttpResponse } from 'msw'

import type { SlipCustomizationByPaymentMethod } from '@/@types/slip-costumization'
import type { SlipSection } from '@/@types/slip-section'

interface MockGetSlipSections {
  alphaId: string
}

export const mockGetSlipSections = http.get<MockGetSlipSections>(
  '/my-business/api/agency/v1/*/:alphaId/slip-sections',
  ({ request }) => {
    const requestURL = new URL(request.url)
    const searchParams = requestURL.searchParams

    if (!searchParams.toString().includes('paymentMethodId')) {
      const slipSections: SlipSection[] = [
        {
          slipSectionId: 1,
          name: 'logotipo da empresa',
          code: 'logoImg',
          paymentMethodInd: 'NOT_APPLY',
          customerInd: 'OPTIONAL',
          infoType: 'LOGO_IMG',
        },
        {
          slipSectionId: 2,
          name: 'instruções para cobrança',
          code: 'billing',
          paymentMethodInd: 'MANDATORY',
          customerInd: 'OPTIONAL',
          infoType: 'TEXT',
        },
        {
          slipSectionId: 3,
          name: 'emissão de nota fiscal',
          code: 'invoice',
          paymentMethodInd: 'OPTIONAL',
          customerInd: 'OPTIONAL',
          infoType: 'COMPLEX',
        },
        {
          slipSectionId: 4,
          name: 'envio da documentação',
          code: 'document',
          paymentMethodInd: 'OPTIONAL',
          customerInd: 'OPTIONAL',
          infoType: 'COMPLEX',
        },
      ]

      return HttpResponse.json({ data: slipSections }, { status: 200 })
    }

    const searchParamsWithoutEchoToken = searchParams
      .toString()
      .split('%3F')
      .at(0)

    const paymentMethodId = searchParamsWithoutEchoToken
      ? searchParamsWithoutEchoToken.split('=')[1]
      : null

    if (paymentMethodId) {
      const slipSections: SlipCustomizationByPaymentMethod[] = [
        {
          inheritedFrom: 'AGENCY_CHAIN',
          paymentMethodId: Number(paymentMethodId),
          slipCustomizationAlphaId: faker.string.uuid(),
          slipSectionId: 1,
        },
        {
          inheritedFrom: 'AGENCY_CHAIN',
          paymentMethodId: Number(paymentMethodId),
          slipCustomizationAlphaId: faker.string.uuid(),
          slipSectionId: 2,
        },
        {
          inheritedFrom: 'AGENCY_CHAIN',
          paymentMethodId: Number(paymentMethodId),
          slipCustomizationAlphaId: faker.string.uuid(),
          slipSectionId: 3,
        },
        {
          inheritedFrom: 'AGENCY_CHAIN',
          paymentMethodId: Number(paymentMethodId),
          slipCustomizationAlphaId: faker.string.uuid(),
          slipSectionId: 4,
        },
      ]

      return HttpResponse.json({ data: slipSections }, { status: 200 })
    }
  },
)
